import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { analyticsService } from '@/lib';

export function RouteTracker(): JSX.Element {
  const location = useLocation();
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    const currentPath = location.pathname;

    if (prevPath.current && prevPath.current !== currentPath) {
      analyticsService.track('route_change', {
        from: prevPath.current,
        to: currentPath,
      });
    }

    analyticsService.track('page_view', {
      path: currentPath,
    });

    prevPath.current = currentPath;
  }, [location.pathname]);

  return <Outlet />;
}